import React from 'react'
import walletminus from "../../../../assets/img/dashboard/wallet-minus.svg"
import cardrecieve from "../../../../assets/img/dashboard/card-receive.svg"
import cardremoved from "../../../../assets/img/dashboard/card-remove.svg"
import Button from '../../../shared/Button'
import PersianNumber from '../../../shared/PersianNumber'
const MyWalletBos = ({walletInfo,setWithdraw}) => {
  return (
    <div className='MyWalletBos'>
        <div className='d-flex-space MyWalletBos--title'>
            <h3>کیف پول شما</h3>
            <Button varient="borderbot" onClick={()=>setWithdraw()}>
            برداشت از کیف پول
            </Button>
        </div>
        <hr className='mt-[30px] '/>
        <div className='MyWalletBos--grid'>
        <div className='MyWalletBos-box'>
            <div className='MyWalletBos-box-iconbox MyWalletBos-box-iconbox-green'>
                <img src={walletminus}/>
            </div>
          <div className='MyWalletBos-box-costinfo'>
          <p>
            موجودی حساب شما
            </p>
            <h6 className='Danafont'><PersianNumber number={walletInfo.wallet_amount} /><span>ریال</span></h6>
          </div>

        </div>
        <div className='MyWalletBos-box'>
            <div className='MyWalletBos-box-iconbox MyWalletBos-box-iconbox-orange'>
                <img src={cardrecieve}/>
            </div>
          <div className='MyWalletBos-box-costinfo'>
          <p>
            مبلغ قابل برداشت
            </p>
            <h6 className='Danafont'><PersianNumber number={walletInfo.free_balance} /> <span>ریال</span></h6>

          </div>
        </div>
        <div className='MyWalletBos-box'>
            <div className='MyWalletBos-box-iconbox MyWalletBos-box-iconbox-purple'>
                <img src={walletminus}/>
            </div>
           <div className='MyWalletBos-box-costinfo'> <p>
            مبلغ بلوکه شده
            </p>
            <h6 className='Danafont'><PersianNumber number={walletInfo.block_balance} /> <span>ریال</span></h6>
</div>
        </div>
        </div>
    </div>
  )
}

export default MyWalletBos